import { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import { ReactComponent as IncidentIconSvg } from './IncidentIconSvg.svg';
import { ReactComponent as HealthIconSvg } from './HealthIconSvg.svg';
import { ReactComponent as CommitmentIconSvg } from './CommitmentIconSvg.svg';
import { ReactComponent as TrainingIconSvg } from './TrainingIconSvg.svg';
import { ReactComponent as ResponsibilityIconSvg } from './ResponsibilityIconSvg.svg';
import { ReactComponent as UnderstandingIconSvg } from './UnderstandingIconSvg.svg';
import { ReactComponent as SafetyIconSvg } from './SafetyIconSvg.svg';
import { ReactComponent as TrainingBoldIconSvg } from './TrainingBoldIconSvg.svg';
import { ReactComponent as ResponsibilityBoldIconSvg } from './ResponsibilityBoldIconSvg.svg';
import { ReactComponent as UnderstandingBoldIconSvg } from './UnderstandingBoldIconSvg.svg';
import { ReactComponent as SafetyBoldIconSvg } from './SafetyBoldIconSvg.svg';

export const IncidentIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <IncidentIconSvg ref={ref} {...props} />);
export const HealthIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <HealthIconSvg ref={ref} {...props} />);
export const CommitmentIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CommitmentIconSvg ref={ref} {...props} />);
export const UnderstandingIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <UnderstandingIconSvg ref={ref} {...props} />);
export const ResponsibilityIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ResponsibilityIconSvg ref={ref} {...props} />);
export const TrainingIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TrainingIconSvg ref={ref} {...props} />);
export const SafetyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SafetyIconSvg ref={ref} {...props} />);

export const UnderstandingBoldIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <UnderstandingBoldIconSvg ref={ref} {...props} />
));
export const ResponsibilityBoldIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ResponsibilityBoldIconSvg ref={ref} {...props} />
));
export const TrainingBoldIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TrainingBoldIconSvg ref={ref} {...props} />);
export const SafetyBoldIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SafetyBoldIconSvg ref={ref} {...props} />);
